import { hasInternalApi, internalApiPost } from './internalApi'
import { supabase } from './supabase'
import { buildRetryPatch } from './callRetryPolicy'
import type { CallRecord } from './useCalls'

export { getRetryTargetStatus } from './callRetryPolicy'

export async function retryFailedCall(
  call: Pick<CallRecord, 'id' | 'status' | 'audio_storage_path' | 'transcript'>
): Promise<void> {
  if (hasInternalApi()) {
    const target = getInternalApiRetryTarget(call)
    if (!target) {
      throw new Error('この通話は再試行できません。音声ファイルまたは文字起こしが残っていません。')
    }
    await internalApiPost<{ call: CallRecord }>(`/api/calls/${call.id}/retry`, {
      expected_status: call.status
    })
    return
  }

  const patch = buildRetryPatch(call)
  if (!patch) {
    throw new Error('この通話は再試行できません。音声ファイルまたは文字起こしが残っていません。')
  }

  const { data, error } = await supabase
    .from('call_records')
    .update(patch)
    .eq('id', call.id)
    .eq('status', 'failed')
    .select('id')
    .maybeSingle()
  if (error) throw error
  if (!data) {
    throw new Error('再試行対象の通話が見つかりません。すでに処理が進んでいる可能性があります。')
  }
}

function getInternalApiRetryTarget(
  call: Pick<CallRecord, 'status' | 'audio_storage_path' | 'transcript'>
): 'pending' | 'awaiting_summary' | null {
  if (!['failed', 'transcribing', 'summarizing'].includes(call.status)) return null
  if (call.audio_storage_path?.trim()) return 'pending'
  if (call.transcript && call.transcript.trim().length >= 20) return 'awaiting_summary'
  return null
}
